import axios from 'axios'
import config from '@/config'
import LogService from './support/LogService'

// When the project frontend is complete, these calls will be unnecessaries.
const requestRPCPlatform = async (methodName: any, params: any) => {
  try {
    const rpcEndpoint = 'bmp.rpc'
    const messageBody = {
      'object': 'API',
      'method': methodName,
      'params': params
    }
    const configUrl = {
      headers: { 'Content-Type': 'text/plain' },
      withCredentials: true
    }
    // Remove the termination from the url
    // apiPlatformUrl = https://{stage}.bluemessaging.net/rest/v0/
    let url = config.apiPlatformUrl.slice(0, -8)
    url = `${url}${rpcEndpoint}`
    const response = await axios.post(url, messageBody, configUrl)
    return response.data
  } catch (error) {
    LogService.error('Error on requestRPCPlatform: ' + error)
    throw error
  }
}

export default requestRPCPlatform
